import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_ImageDepixelizer = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/unpixelate-image',
			name: 'Unpixelate Image Online',
			description:
				'Remove pixelation from images instantly with AI. Online unpixelate tool — no watermarks, no downloads ',
			url: 'https://liftapp.ai/unpixelate-image',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/unpixelate-image#product' },
				{ '@id': 'https://liftapp.ai/unpixelate-image#howto' },
				{ '@id': 'https://liftapp.ai/unpixelate-image#benefits' },
				{ '@id': 'https://liftapp.ai/unpixelate-image#faq' },
				{ '@id': 'https://liftapp.ai/unpixelate-image#why-lift' },
				{ '@id': 'https://liftapp.ai/unpixelate-image#explore-tools' },
				{ '@id': 'https://liftapp.ai/unpixelate-image#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/unpixelate-image#product',
			name: 'Unpixelate Image Online',
			description:
				'Remove pixelation from images instantly with AI. Online unpixelate tool — no watermarks, no downloads ',
			url: 'https://liftapp.ai/unpixelate-image',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/unpixelate-image#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Let AI depixelate it',
					text: "Lift's AI removes pixelation, restores details, and increases image quality automatically",
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/unpixelate-image#benefits',
			name: 'Who can benefit from AI Image Depixelizer?',
			description:
				'Lift AI Image Depixelizer helps e-commerce sellers, content creators, marketers, and more improve image quality instantly with AI retouching.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'AI unpixelate technology is perfect for anyone dealing with low-resolution or compressed images',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Content creators and influencers for professional-looking posts',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Businesses and e-commerce sellers improving product visuals',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Event planners preserving memories in crisp detail',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Students or professionals can clarify scanned documents, screenshots, or images',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Photographers can restore older or low-quality images effortlessly',
				},
				{
					'@type': 'ListItem',
					position: 7,
					name: 'AI Image Depixelizer bridges the gap between unusable photos and professional-grade visuals, making it essential for both personal and business needs',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/Landing_2.0b784d4b.webp',
				name: '',
				description: '',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/unpixelate-image#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Image Depixelizer?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Image Depixelizer is a premium online tool that improves photo clarity, colour and resolution up to 4K in a single click.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift unpixelate images?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'AI depixelize photo quality uses a two-step deep-learning process: first, a smart denoiser cleans blur and noise; next, a super-resolution model rebuilds lost pixels, boosts colours and sharpens edges all the way up to crisp 4K. Everything runs in the cloud, so you get pro-level photo quality with one click.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can it fix heavily pixelated or compressed images?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI is trained to depixelate images affected by heavy compression, low resolution, or poor quality. It recovers lost details, smooths blocky areas, and enhances overall clarity — making even severely pixelated photos look sharp and professional again.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download unpixelated images without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/unpixelate-image#why-lift',
			name: "Why Lift's AI unpixelate tool stands out",
			description:
				"Lift's AI Image Depixelizer provides professional results, AI accuracy, cross-platform support, and is budget-friendly.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyLift.bab0bb04.webp',
				name: '',
				description: '',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-extender#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/unpixelate-image#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Image Depixelizer',
					item: 'https://liftapp.ai/unpixelate-image',
				},
			],
		},
	],
};
